/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import DTOActiveDocs from './DTOActiveDocs';
import ActiveDocsPresenter from './ActiveDocsPresenter';
import { useAppSelector, useAppDispatch } from '../../../../infra/hooks';
import { documentService } from '../../../../api/services/documentService';
import DownloadDocController from '../DownloadDocs/DownloadDocController';
import { toast } from 'react-hot-toast';
import _ from 'lodash';
import { setEmployeeActiveDocs } from '../../../../infra/aggregates/myProfile/DocumentAggregates/getActiveEmpDocsSlice';
import { useTranslation } from 'react-i18next';

function ActiveDocsController() {
  const { t } = useTranslation();

  const [DocsData, setDocsData] = useState([]);
  const [attachmentUrl, setAttachmentUrl] = useState('');
  const [open_modal, setOpenModal] = useState(false);

  const dispatch = useAppDispatch();

  const isLoading = useAppSelector(
    (state) => state.getActiveEmpDocsSlice.activeDocLoader,
  );
  function callBackFunc(data: any) {
    setDocsData(data);
  }
  const store_ActiveDocuments: any = useAppSelector(
    (state) => state.getActiveEmpDocsSlice.empDocsData,
  );
  const full_path = '';
  const getAttchedDocs = async (id: number) => {
    const response: any = await documentService.getAttachedDoc(id, full_path);

    if (response.response == 'success') {
      const url = response.data.attachment;
      if (url != null) {
        setAttachmentUrl(url);
        setOpenModal(true);
      } else {
        toast.error(t('There is no Attached file'));
      }
    }
  };
  const getDocsIdItemToBeDeleted = async (_id: number) => {
    const response: any = await documentService.deleteEmpDocs(_id);
    const tempActiveDocs = [...store_ActiveDocuments];

    if (response.response == 'success') {
      const updatedArray: any = _.filter(tempActiveDocs, (data: any) => {
        return data.id != _id;
      });
      dispatch(setEmployeeActiveDocs(updatedArray));
      toast.success(t('Deleted Successfully'));
    }
  };
  return (
    <>
      <DTOActiveDocs setDocumentsData={callBackFunc} />
      <ActiveDocsPresenter
        allDocsData={DocsData}
        setDocsIdFordeletion={getDocsIdItemToBeDeleted}
        setEmpAttachedDoc={getAttchedDocs}
        isLoading={isLoading}
        trans={t}
      />
      {open_modal && (
        <DownloadDocController
          isModalOpen={open_modal}
          closeModal={() => setOpenModal(false)}
          attachmentUrl={attachmentUrl}
        />
      )}
    </>
  );
}

export default ActiveDocsController;
